/**
 * PreviewRuleActionIcons — the per-action icons for a preview row: one chip per
 * rule action matching the item (set-to-queue / eliminate / add-element), using
 * the SAME glyphs as the Rules-tab ACTIONS picker. `exclude` is omitted by
 * default because the row already renders its dedicated PreviewExcludedIndicator.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import type { RuleAction } from '@trafficpulse/shared';

import { cn } from '@/lib/utils';

import { RULE_ACTION_META } from '../../tabs/exclude/rule-action-meta';

export interface PreviewRuleActionIconsProps {
  actions?: RuleAction[];
  /** Drop `exclude` (the Ban indicator already covers it). Default true. */
  omitExclude?: boolean;
  className?: string;
}

const PreviewRuleActionIcons: FC<PreviewRuleActionIconsProps> = ({
  actions,
  omitExclude = true,
  className,
}) => {
  const shown = (actions ?? []).filter(
    (a) => (!omitExclude || a !== 'exclude') && RULE_ACTION_META[a] && !RULE_ACTION_META[a]?.soon,
  );
  if (shown.length === 0) return null;
  return (
    <span className={cn('inline-flex items-center gap-0.5', className)}>
      {shown.map((action) => {
        const meta = RULE_ACTION_META[action]!;
        const Icon = meta.Icon;
        return (
          <span
            key={action}
            title={meta.label}
            aria-label={meta.label}
            className={cn(
              'inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-sm',
              meta.tone,
            )}
          >
            <Icon className="h-2.5 w-2.5" strokeWidth={2.5} aria-hidden />
          </span>
        );
      })}
    </span>
  );
};

export default PreviewRuleActionIcons;
